// Change listener
CartItems.on("change", function() {
	$(".js-cart-items-count").text(CartItems.count());

	if (CartItems.count())
	{
		$(".js-show-cart-not-empty").show();
		$(".js-show-cart-empty").hide();	
	}
	else {
		$(".js-show-cart-not-empty").hide();	
		$(".js-show-cart-empty").show();	
	}

	// if (CartItems.empty() || !CartItems.acceptTOS) {
	// 	$(".js-btn-order").attr("disabled", true).prop("disabled", true);
	// }
	// else {
	// 	$(".js-btn-order").removeAttr("disabled", true).removeProp("disabled", true);
	// }
});

$(".js-toggle-tos").on("change", function() {

	CartItems.setAcceptTos($(this).is(":checked"));

}).change();

$(".js-payment-method").on("change", function() {

	if ($(this).is(":checked")) {
		CartItems.paymentMethod = $(this).val();
	}

}).change();